import classNames from "classnames";
import { ReactElement } from "react";
import { Anchor } from "../Anchor/Anchor";
import { Icon } from "../Icon/Icon";
import styles from "./ActionListItem.module.less";

export type ActionListSubMenuHeaderProps = {
	text: string;
	onGoBack(): void;
};

export const ActionListSubMenuHeader = (props: ActionListSubMenuHeaderProps): ReactElement => {
	const {
		text,
		onGoBack
	} = props;

	return (
		<li>
			<Anchor
				className={classNames(
					styles.root,
					styles.root_hoverable
				)}
				onClick={onGoBack}
			>
				<div className={styles.contentHost}>
					<span
						className={classNames(
							styles.icon,
							styles.icon_back
						)}
					>
						<Icon value="chevron-left" />
					</span>

					<span
						className={classNames(
							styles.text,
							styles.text_header,
							styles.text_centered
						)}
					>
						{text}
					</span>
				</div>
			</Anchor>
		</li>
	);
};
ActionListSubMenuHeader.displayName="ActionListSubMenuHeader";